var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing",attrs:{"fluid":"","fill-height":""}},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary","height":"20"}}),_c('v-card-text',{staticClass:"text-caption text-center"},[_vm._v(" "+_vm._s(_vm.$t('message.loading_jiu_jitsu'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }